import React, { useState } from "react";
import { Button, Form, Modal, Table } from "antd";
import "./AddToStock.css";
import RfidColumnList from "./RfidColumnList";
import { readRFID } from "api/roamingItems.api";
import { AddToStockProps } from "domain/RoamingItems";

const AddToStock: React.FC<AddToStockProps> = ({
  isModalOpen,
  setIsModalOpen,
  selectedRow,
}) => {
  const { GarmentId, Item, Color, Stock } = selectedRow;
  const [form] = Form.useForm();
  const modalStyle = { height: "76vh", overflow: "hidden" };
  const data = [{ key: GarmentId, item: Item, color: Color, inStock: Stock }];

  const [isLoading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isReading, setIsReading] = useState(false);
  const [roamingAffiliation, setRoamingAffiliation] = useState([]);

  const handleOk = async () => {
    try {
      setIsSubmitted(true);
      const values = await form.validateFields();
      const payload = { ...values };
      console.log(payload);
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitted(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen((prev) => ({ ...prev, addToStockForm: false }));
  };

  const handleRead = async (roamingItemId: string) => {
    try {
      setIsReading(true);
      const response = await readRFID(roamingItemId);
      console.log(response);
      // blocker from backend
    } catch (error) {
      console.error("Error reading RFID:", error);
    } finally {
      setIsReading(false);
    }
  };

  return (
    <Modal
      title={"Add to stock"}
      width={"34.4rem"}
      centered
      visible={isModalOpen}
      bodyStyle={modalStyle}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={false}
    >
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          loading={isReading}
          onClick={() => handleRead(GarmentId.toString())}
          type="primary"
        >
          Read
        </Button>
        <Button type="primary">Add Items</Button>
        <Button onClick={handleCancel} type="primary">
          Cancel
        </Button>
      </div>

      <Table
        columns={[
          { title: "Item", dataIndex: "item" },
          { title: "Color", dataIndex: "color" },
          { title: "In Stock", dataIndex: "inStock" },
        ]}
        dataSource={data}
        pagination={false}
        rowKey="key"
      />

      <RfidColumnList rfids={roamingAffiliation} />
    </Modal>
  );
};

export default AddToStock;
